import { Inject, Injectable } from '@angular/core';

import { AbstractLanguageService } from '@abstract-services/language/1.0/language.abstract-service';
import { LANGUAGE_LIST } from '@models/language-list/1.0';
import { Language } from '@models/language/1.0';
import { DEFAULT_LANGUAGE, LANGUAGES } from '@modules/i18n/1.0';

@Injectable({
  providedIn: 'root',
})
export class LanguageService implements AbstractLanguageService {
  constructor(
    @Inject(LANGUAGES) private languages: any,
    @Inject(DEFAULT_LANGUAGE) private defaultLanguageCode: any,
  ) {}

  get defaultLanguage(): Language {
    return LANGUAGE_LIST.find((language: Language) => language.code === this.defaultLanguageCode);
  }

  getAll(): Language[] {
    return LANGUAGE_LIST.filter((language: Language) => this.languages.indexOf(language.code) >= 0);
  }
}
